// socials
export default {
  facebook: "https://www.facebook.com/MINIDAYZGAME/",
  youtube: "https://www.youtube.com/channel/UCVEsMNqwFgoDrgCCSQ-RTfg",
  twitter: "https://twitter.com/MINIDAYZGAME",
  vk: "https://vk.com/mini_dayz",

  //
  cookies: "https://www.bistudio.com/cookie-policy",
  privacyPolicy: "https://www.bistudio.com/privacy-policy",

  // support
  supportMobile:
    "https://minidayz.com/blog/mini-dayz-future-and-further-development",
  supportBrowser:
    "https://minidayz.com/blog/mini-dayz-browser-version-will-no-longer-be-supported"
};
